var map = {
	"./site-logo-desktop-footer.svg": 87767,
	"./site-logo-desktop.svg": 65441,
	"./site-logo-drawer-mobile.svg": 71779,
	"./site-logo-drawer.svg": 28832,
	"./site-logo-mobile-drawer.svg": 8365,
	"./site-logo-mobile.svg": 87125,
	"./site-logo-sm.svg": 40647,
	"./site-logo-tv.svg": 1581,
	"./site-logo-wrapper-mobile-scrolled.svg": 82088,
	"./site-logo-wrapper-mobile.svg": 57063,
	"./site-logo-wrapper-scrolled.svg": 49553,
	"./site-logo-wrapper.svg": 83156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99526;